module.exports = __webpack_public_path__ + "h5/img/top.5e01b4ea.png";